<app-ginop-header [title]="'Please choose a location'" [image]="image"></app-ginop-header>

<section class="ginop-list">
  <div class="specicon icon-city-notitle-sopron"></div>
  <div class="ginop-list-description"></div>
  <div class="ginop-cards">
    <ng-container *ngFor="let event of eventList">
      <a
        [routerLink]="['/', 'b2b-events', event.slug]"
        *ngIf="event"
        [class.disabled]="event.overOfDeadline || (!event.exhibitorReg && !event.participantReg)"
        class="ginop-card"
      >
        <span
          class="card-bg"
          *ngIf="event?.imageObj?.url"
          [style.background-image]="'url(' + event.imageObj.url + ')' | ssrEmptyString"
          [attr.aria-label]="event?.imageObj?.image?.title"
          role="img"
        ></span>
        <div class="card-overlay"></div>
        <div class="card-location" *ngIf="event.city">
          {{ event.country }} <br />
          {{ event.city }}
        </div>
        <div class="card-date" *ngIf="event.date">
          {{ event.date | dateFormat }} <br />
          {{ event.date | dateFormat : 'dddd' }}
        </div>
        <div class="card-button"><i class="icon icon-ginop-arrow"></i></div>
      </a>
    </ng-container>
  </div>
</section>
